import { render, staticRenderFns } from "./DataTableRowHandler.vue?vue&type=template&id=48dccf19&scoped=true&"
import script from "./DataTableRowHandler.vue?vue&type=script&lang=js&"
export * from "./DataTableRowHandler.vue?vue&type=script&lang=js&"
import style0 from "./DataTableRowHandler.vue?vue&type=style&index=0&id=48dccf19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dccf19",
  null
  
)

export default component.exports